import { render } from "./VUserMenu.vue?vue&type=template&id=72a67168&ts=true"
import script from "./VUserMenu.vue?vue&type=script&lang=ts"
export * from "./VUserMenu.vue?vue&type=script&lang=ts"

import "./VUserMenu.vue?vue&type=style&index=0&id=72a67168&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__